import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import { useTheme } from '@material-ui/core/styles';
import openIcon from '../../assets/openInNew.png';

export const LeavingSiteConfirmation = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.handleClose} open={props.open}>
     
      <Box className={classes.root}>
        <IconButton className={classes.closeIcon} onClick={() => props.handleClose()}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>You Are Leaving This Website</Typography>
        </Box>
        
        <Box className={classes.cardBody2}>
           <Box className={classes.cardContainer}>
            <Box className={classes.imageContainer}>
             <Typography className={classes.paragraph}>You are being redirected to another BSI affiliated website to start your application. Click <b>Continue</b> to proceed.</Typography>
             </Box>
             <Typography className={classes.paragraph}><span className={classes.important}>Important: </span>This site uses a separate login.</Typography>
              <Typography className={classes.paragraph}>You’ll need to create a <b>new username and password</b> — your <b>MyLoanWeb</b> credentials won’t work there.</Typography>
            </Box> 
        </Box>

        <Box className={classes.cardFooter}>
         <Box className={classes.footerItem}>
            <Button
              variant='outlined'
              className={classes.btn}
              onClick={props.handleClose}
            > Stay here</Button>
          </Box>

          <Box className={classes.footerItem}>
              <Button
                variant='contained'
                color='primary'
                className={classes.btn}
                onClick={props.handleOk}
              >Continue <img src={openIcon} className={classes.openIcon}/></Button>
          </Box> 
        </Box>
       
      </Box> 
    </Dialog>
  )
}
